import React, { useState, useEffect } from 'react';
import { mediaTypes } from 'components/posts';
import NewsCard from '../../cards/js/news-card';
import RelatedNews from '../../related-news/js/related-news';
import { useScreenDetector } from '../../../general/js/hooks/useScreenDetector';

const LiveCardLatestNewsVideos = ({ contentItems, loadMoreVideosUrl, viewMoreVideosText }) => {
    const [displayedVideos, setDisplayedVideos] = useState([]);

    const { isMobile } = useScreenDetector();
    useEffect(() => {
        const initialVideos = contentItems.slice(0, 7);
        setDisplayedVideos(initialVideos);
    }, [contentItems]);

    const handleLoadMoreClick = () => {
        window.location.href = loadMoreVideosUrl || 'https://www.randa.tv';
    };

    const mapVideoToModel = (video) => ({
        id: video.id,
        url: `https://www.randa.tv/video/${video.id}`,
        bgImage: video.thumbnailUrl,
        label: video.type,
        title: video.title,
        subtitle: video.description || '',
        ctaText: 'Watch now',
        type: mediaTypes.VIDEO_PLAYER,
        schemaOrg: video.schemaOrg || {},
    });

    if (displayedVideos.length === 2) {
        return (
            <div className="live-card-latest-news-videos">
                <div className="live-card-latest-news-videos__group">
                    {displayedVideos.map((video) => (
                        <div className="live-card-latest-news-videos__wrapper" key={video.id}>
                            <div className="live-card-latest-news-videos__item">
                                <NewsCard model={mapVideoToModel(video)} bemModifiers={['one-third']}/>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="live-card-latest-news-videos__loadmore">
                    <button className="button button--primary" type="button" onClick={handleLoadMoreClick}>
                        {viewMoreVideosText || 'View More videos'}
                    </button>
                </div>
            </div>
        );
    }

    if (displayedVideos.length > 0) {
        return (
            <div className="live-card-latest-news-videos">
                {!isMobile ? (
                    <div className="live-card-latest-news-videos__group">
                        <div className="live-card-latest-news-videos__wrapper">
                            <div className="live-card-latest-news-videos__item">
                                <NewsCard model={mapVideoToModel(displayedVideos[0])} bemModifiers={['one-third']}/>
                            </div>
                        </div>
                        <div className="live-card-latest-news-videos__wrapper">
                            <div className="live-card-latest-news-videos__item">
                                <RelatedNews
                                    model={displayedVideos.slice(1).map(mapVideoToModel)}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="live-card-latest-news-videos__group">
                        <div className="live-card-latest-news-videos__wrapper">
                            <div className="live-card-latest-news-videos__item">
                                <RelatedNews
                                    model={displayedVideos.map(mapVideoToModel)}
                                />
                            </div>
                        </div>
                    </div>
                )}
                <div className="live-card-latest-news-videos__loadmore">
                    <button className="button button--primary" type="button" onClick={handleLoadMoreClick}>
                        {viewMoreVideosText || 'View More videos'}
                    </button>
                </div>
            </div>
        );
    }

    return (<></>);
};

export default LiveCardLatestNewsVideos;
